import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './HelpWidget.scss';

const HelpWidget = () => {
  const { t, i18n } = useTranslation();

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-buoy sb-options">
      <button
        type="button"
        className="sb-buoy-button"
        aria-label="User Menu"
        onClick={() => setShowDropdownMenu(!showDropdownMenu)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M4.92999 4.92999L9.16999 9.16999"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M14.83 14.83L19.07 19.07"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M14.83 9.16999L19.07 4.92999"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M14.83 9.17001L18.36 5.64001"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M4.92999 19.07L9.16999 14.83"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      </button>
      <div
        ref={dropdownMenu}
        className={
          'sb-buoy-options-menu sb-options-menu ' +
          (showDropdownMenu ? 'sb-show' : 'sb-hide')
        }
      >
        <div className="sb-options-menu-content">
          <a
            href="https://support.devhub.com/hc/en-us/requests/new"
            className="sb-options-item sb-options-item-linkout"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M3.66671 3.66663H18.3334C19.3417 3.66663 20.1667 4.49163 20.1667 5.49996V16.5C20.1667 17.5083 19.3417 18.3333 18.3334 18.3333H3.66671C2.65837 18.3333 1.83337 17.5083 1.83337 16.5V5.49996C1.83337 4.49163 2.65837 3.66663 3.66671 3.66663Z"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M20.1667 5.5L11 11.9167L1.83337 5.5"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            Contact us{' '}
          </a>
          <a
            href="https://support.devhub.com/hc/en-us"
            className="sb-options-item"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M11 20.1667C16.0627 20.1667 20.1667 16.0627 20.1667 11C20.1667 5.93743 16.0627 1.83337 11 1.83337C5.93743 1.83337 1.83337 5.93743 1.83337 11C1.83337 16.0627 5.93743 20.1667 11 20.1667Z"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M8.33252 8.25003C8.54803 7.6374 8.97341 7.1208 9.53331 6.79174C10.0932 6.46268 10.7515 6.34239 11.3916 6.45219C12.0317 6.56198 12.6123 6.89476 13.0305 7.3916C13.4487 7.88844 13.6777 8.51726 13.6767 9.1667C13.6767 11 10.9267 11.9167 10.9267 11.9167"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M11 15.5834H11.0098"
                stroke="#002E4C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            Help center
          </a>
          <a
            href="https://www.devhub.com/"
            className="sb-options-item"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M18.3334 2.75H3.66671C2.65419 2.75 1.83337 3.57081 1.83337 4.58333V13.75C1.83337 14.7625 2.65419 15.5833 3.66671 15.5833H18.3334C19.3459 15.5833 20.1667 14.7625 20.1667 13.75V4.58333C20.1667 3.57081 19.3459 2.75 18.3334 2.75Z"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M7.33337 19.25H14.6667"
                stroke="#002E4C"
                strokeOpacity="0.894118"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M11 15.5834V19.25"
                stroke="#002E4C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            Visit our homepage
          </a>
        </div>
      </div>
    </div>
  );
};

export default HelpWidget;
